module.exports = __webpack_public_path__ + "img/home_bg.d1f61e00.png";